import React from 'react'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { use as useWs } from '../../shared/websockets'
import { getConversationsAsync } from '../../Module/WS/websockets'

const styles = {
  wrapper: { height: '100%', display: 'flex', alignItems: 'center' },
  connected: { color: 'green' },
  disconnected: { color: 'orange' },
  disconnectedLabel: { marginLeft: '4px' },
  disconnectedButtonContent: { display: 'flex', alignItems: 'center' },
}

const WSConnectionIndicator = ({ websocketsConnected }) => {
  if (websocketsConnected) {
    return (
      <div style={styles.wrapper}>
        <CheckCircleOutlineIcon style={styles.connected} />
      </div>
    )
  }

  const handleReconnect = () => {
    if (!websocketsConnected) {
      return useWs({
        onConnect: () =>
          getConversationsAsync({
            ack: 'reconnectUpdate',
            first: 20,
            archived: false,
          }),
      })
    }
  }

  return (
    <Button
      onClick={handleReconnect}
      style={styles.disconnected}
      size="small"
      startIcon={<ErrorOutlineIcon />}
    >
      <div style={styles.disconnectedButtonContent}>
        <ErrorOutlineIcon />
        <span style={styles.disconnectedLabel}>Reconnect</span>
      </div>
    </Button>
  )
}

const mapStateToProps = state => {
  return {
    websocketsConnected: state.websockets.connected,
  }
}

export default connect(mapStateToProps)(WSConnectionIndicator)



// WEBPACK FOOTER //
// ./src/Components/WSConnectionIndicator/WSConnectionIndicator.js